import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bc",
  "use": "icon-bc-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-bc\">\n<g id=\"icon-bc_Menu/bc\">\n<path id=\"icon-bc_save\" d=\"M11 2L14 5V13C14 13.5523 13.5523 14 13 14H3C2.44772 14 2 13.5523 2 13V3C2 2.44772 2.44772 2 3 2H11ZM10 3L6 3V4.5H10V3ZM11 3.41421V5.5H5V3L3 3L3 13H5V8H11V13H13V5.41421L11 3.41421ZM10 13V9H6V13H10Z\" fill=\"#282C33\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/bc.svg
// module id = +CJ7
// module chunks = 140